"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleLoader = exports.TableLoader = void 0;
const styles_1 = require("@mui/material/styles");
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
exports.TableLoader = (0, styles_1.styled)(Skeleton_1.default)({
    height: "400px",
    width: "100%",
});
exports.TitleLoader = (0, styles_1.styled)(Skeleton_1.default)({
    width: "100%",
    height: "36px"
});
